module.exports = __webpack_public_path__ + "media/images/osu-wordmark-1ac1a0a28f37c539fe0c54b33c600e63.png";